import React from "react";
import { TForm, TInputElementProps, TInputProps } from "@/components/form/types";
import Label from "@/components/form/label";
import useForm from "@/components/form/index";
import NorwaySVG from "@/assets/icons-js/flags/round/norway";
import { AsYouType } from "libphonenumber-js";

type TPhoneInput = {
    country: string,
    dial_code: string,
    number: string,
};
export const PhoneInput = (props: TInputElementProps<TPhoneInput>) => {
    const { container, className, label, tooltip, options, hidden, input } = props;

    if (hidden) {
        return null;
    }

    return (
        <div className={["input__container input--phone", container?.className ?? className].join(" ")}>
            <Label {...label} tooltip={tooltip} options={options}/>
            <div>
                <div>
                    <NorwaySVG/>
                </div>
                {/* @ts-ignore */}
                <input {...input} value={new AsYouType(input.value.country).input(input.value.number)}/>
            </div>
        </div>
    );
}

const usePhoneInput = <T extends TPhoneInput>(props : TInputProps<T>): TForm<TPhoneInput> => {
    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        form.update({
            ...form.value,
            number: (e.target.value ?? "").replace(/\D/g, ""),
        });
    }

    const form = useForm<TPhoneInput>({
        id: "phone",
        type: "tel",
        default: {
            country: "NO",
            dial_code: "47",
            number: "",
        },
        onChange,
        ...props,
    });

    return {
        ...form,
    }
};

export default usePhoneInput;
